import { GetUrlWithStringIdParameter } from '@/features/srm/types';

export const API_DOCUMENT = '/document';
export const API_DOCUMENT_FILE_ID: GetUrlWithStringIdParameter = (id) => `/documentFile/${id}`;
export const API_DOCUMENT_ID: GetUrlWithStringIdParameter = (id) => `/document/${id}`;
export const API_DOCUMENT_FILE = '/documentFile';
